// sceneneon4L2.glb

/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.2.3 scene.glb
*/

// GRADIENT COLLOR (ANIMATION) USING NOW

import React, { useEffect, useMemo, useRef } from "react";
import { MeshReflectorMaterial, useGLTF } from "@react-three/drei";
import { Color, ShaderMaterial, MeshStandardMaterial } from "three";
import { extend, useFrame } from "@react-three/fiber";
// import { EffectComposer, Bloom } from "@react-three/postprocessing";

// Custom shader material for the gradient
const GradientMaterial = new ShaderMaterial({
  uniforms: {
    color1: { value: new Color("#00ff00") }, // Start color of the gradient
    color2: { value: new Color("#0000ff") }, // End color of the gradient
  },
  vertexShader: `
    varying vec3 vPos;
    void main() {
      vPos = position;
      gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
    }
  `,
  fragmentShader: `
    uniform vec3 color1;
    uniform vec3 color2;
    varying vec3 vPos;
    void main() {
      float mixValue = (vPos.y + 3.852) / 10.0; // Adjust this to fit your scene's scale
      vec3 color = mix(color1, color2, mixValue);
      gl_FragColor = vec4(color, 1.0);
    }
  `,
});

extend({ GradientMaterial });

export function Landscape(props) {
  const { nodes, materials } = useGLTF("assets/models/sceneneon4L2.glb");
  const treeMaterialRef = useRef(null);

  const [lightsMaterial, waterMaterial] = useMemo(() => {
    return [
      new MeshStandardMaterial({
        envMapIntensity: 0,
        color: new Color("#ea6619"),
        roughness: 0,
        metalness: 0,
        emissive: new Color("#f6390f").multiplyScalar(1),
      }),
      <MeshReflectorMaterial
        transparent={true}
        opacity={0.6}
        color={"#23281b"}
        roughness={0}
        blur={[10, 10]} // Blur ground reflections (width, height), 0 skips blur
        mixBlur={1} // How much blur mixes with surface roughness (default = 1)
        mixStrength={20} // Strength of the reflections
        mixContrast={1.2} // Contrast of the reflections
        resolution={512} // Off-buffer resolution, lower=faster, higher=better quality, slower
        mirror={0} // Mirror environment, 0 = texture colors, 1 = pick up env colors
        depthScale={0} // Scale the depth factor (0 = no depth, default = 0)
        minDepthThreshold={0} // Lower edge for the depthTexture interpolation (default = 0)
        maxDepthThreshold={0.1} // Upper edge for the depthTexture interpolation (default = 0)
        depthToBlurRatioBias={
          0.0025
        } /* Adds a bias factor to the depthTexture before calculating the blur amount [blurFactor = blurTexture * (depthTexture + bias)]. It accepts values between 0 and 1, default is 0.25. An amount > 0 of bias makes sure that the blurTexture is not too sharp because of the multiplication with the depthTexture */
        debug={
          0
        } /* Depending on the assigned value, one of the following channels is shown */
        reflectorOffset={
          0.0
        } /* Offsets the virtual camera that projects the reflection. Useful when the reflective surface is some distance from the object's origin (default = 0) */
      />,
    ];
  }, []);

  useEffect(() => {
    const landscapeMat = materials["Material.009"];
    landscapeMat.envMapIntensity = 0.75;
  
    const treesMat = GradientMaterial.clone();
    treesMat.uniforms.color1.value = new Color("#00ff00"); // Gradient start color
    treesMat.uniforms.color2.value = new Color("#0000ff"); // Gradient end color
    treesMat.envMapIntensity = 0.3;
    treesMat.roughness = 1;
    treesMat.metalness = 0;
  
    treeMaterialRef.current = treesMat;
    nodes.trees_light.material = treesMat;
  
    // Start the animation loop for color change
    const animateTreeColor = () => {
      if (treeMaterialRef.current) {
        // const duration = 6000; // Duration in milliseconds for one complete cycle
        const duration = 12000; // Duration in milliseconds for one complete cycle
        const startTime = Date.now();
        const color1 = new Color("#00ff00"); // Gradient start color
        const color2 = new Color("#0000ff"); // Gradient end color
        const color3 = new Color("#ff00ff"); // Purple reddish tone
  
        const updateColor = () => {
          const currentTime = Date.now();
          let elapsedTime = (currentTime - startTime) % duration;
          if (elapsedTime < 0) elapsedTime += duration;
          let t = elapsedTime / duration;
  
          // Smooth transition when looping back
          if (t > 0.5) {
            t = 1.0 - t; // Reverse the progress to smoothly transition back
          }
  
          // Interpolate colors
          const mixColor1 = color1.clone().lerp(color2, t * 2);
          const mixColor2 = color2.clone().lerp(color3, t * 2);
  
          treeMaterialRef.current.uniforms.color1.value.copy(mixColor1);
          treeMaterialRef.current.uniforms.color2.value.copy(mixColor2);
  
          requestAnimationFrame(updateColor);
        };
  
        updateColor();
      }
    };
  
    animateTreeColor();
  
    return () => {
      if (treeMaterialRef.current) {
        treeMaterialRef.current.dispose();
      }
    };
  }, [materials, nodes]);
  
  

  return (
    <>
      <group {...props} dispose={null}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.landscape_gltf.geometry}
          material={materials["Material.009"]}
          position={[0, -3.852, -3.686]}
          scale={[2.003, 1.938, 1.993]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.landscape_borders.geometry}
          material={materials["Material.010"]}
          position={[0, -3.852, -3.686]}
          scale={[2.003, 1.938, 1.993]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.trees_light.geometry}
          material={nodes.trees_light.material} // Use the updated material
          position={[0, -3.852, -3.686]}
          scale={[2.003, 1.938, 1.993]}
        />
      </group>
      {/* <EffectComposer>
        <Bloom intensity={1.5} luminanceThreshold={0.2} luminanceSmoothing={0.9} />
      </EffectComposer> */}
    </>
  );
}

useGLTF.preload("/sceneneon4L2.glb");



















// ORIGINAL (NO GRADIENT) BLUE

// import React, { useEffect, useMemo } from "react";
// import { MeshReflectorMaterial, useGLTF } from "@react-three/drei";
// import { Color, MeshStandardMaterial } from "three";

// export function Landscape(props) {
//   const { nodes, materials } = useGLTF("assets/models/sceneneon4L2.glb");

//   const [lightsMaterial, waterMaterial] = useMemo(() => {
//     return [
//       new MeshStandardMaterial({
//         envMapIntensity: 0,
//         color: new Color("#ea6619"),
//         roughness: 0,
//         metalness: 0,
//         emissive: new Color("#f6390f").multiplyScalar(1),
//       }),
//       <MeshReflectorMaterial
//         transparent={true}
//         opacity={0.6}
//         color={"#23281b"}
//         roughness={0}
//         blur={[10, 10]} // Blur ground reflections (width, height), 0 skips blur
//         mixBlur={1} // How much blur mixes with surface roughness (default = 1)
//         mixStrength={20} // Strength of the reflections
//         mixContrast={1.2} // Contrast of the reflections
//         resolution={512} // Off-buffer resolution, lower=faster, higher=better quality, slower
//         mirror={0} // Mirror environment, 0 = texture colors, 1 = pick up env colors
//         depthScale={0} // Scale the depth factor (0 = no depth, default = 0)
//         minDepthThreshold={0} // Lower edge for the depthTexture interpolation (default = 0)
//         maxDepthThreshold={0.1} // Upper edge for the depthTexture interpolation (default = 0)
//         depthToBlurRatioBias={0.0025} // Adds a bias factor to the depthTexture before calculating the blur amount [blurFactor = blurTexture * (depthTexture + bias)]. It accepts values between 0 and 1, default is 0.25. An amount > 0 of bias makes sure that the blurTexture is not too sharp because of the multiplication with the depthTexture
//         debug={
//           0
//         } /* Depending on the assigned value, one of the following channels is shown */
//         reflectorOffset={0.0} // Offsets the virtual camera that projects the reflection. Useful when the reflective surface is some distance from the object's origin (default = 0)
//       />,
//     ];
//   }, []);

//   useEffect(() => {
//     const landscapeMat = materials["Material.009"];
//     landscapeMat.envMapIntensity = 0.75;

//     const treesMat = materials["Material.008"];
//     treesMat.color = new Color("#2f2f13");
//     treesMat.envMapIntensity = 0.3;
//     treesMat.roughness = 1;
//     treesMat.metalness = 0;
//   }, [materials]);


//   return (
//     <group {...props} dispose={null}>
//       <mesh
//         castShadow
//         receiveShadow
//         geometry={nodes.landscape_gltf.geometry}
//         material={materials['Material.009']}
//         position={[0, -3.852, -3.686]}
//         scale={[2.003, 1.938, 1.993]}
//       />
//       <mesh
//         castShadow
//         receiveShadow
//         geometry={nodes.landscape_borders.geometry}
//         material={materials['Material.010']}
//         position={[0, -3.852, -3.686]}
//         scale={[2.003, 1.938, 1.993]}
//       />
//       <mesh
//         castShadow
//         receiveShadow
//         geometry={nodes.trees_light.geometry}
//         material={materials['Material.008']}
//         position={[0, -3.852, -3.686]}
//         scale={[2.003, 1.938, 1.993]}
//       />
//       {/* <mesh
//         castShadow
//         receiveShadow
//         geometry={nodes.water.geometry}
//         material={materials.Water}
//         position={[0, -3.852, -3.686]}
//         scale={[2.003, 1.938, 1.993]}
//       /> */}
//       {/* <mesh
//         castShadow
//         receiveShadow
//         geometry={nodes.water1.geometry}
//         material={materials.Water}
//         position={[0, -3.852, -3.686]}
//         scale={[2.003, 1.938, 1.993]}
//       /> */}
//       {/* <mesh
//         castShadow
//         receiveShadow
//         geometry={nodes.water2.geometry}
//         material={materials.Water}
//         position={[0, -3.852, -3.686]}
//         scale={[2.003, 1.938, 1.993]}
//       /> */}
//     </group>
//   )
// }

// useGLTF.preload('/sceneneon4L2.glb')
















































// // GRADIENT COLOR WITH BLOOM (COMMENT OUT BLOOM) NO ANIMATION

// import React, { useEffect, useMemo } from "react";
// import { MeshReflectorMaterial, useGLTF } from "@react-three/drei";
// import { Color, ShaderMaterial, MeshStandardMaterial } from "three";
// import { extend, useFrame } from "@react-three/fiber";
// import { EffectComposer, Bloom } from "@react-three/postprocessing";

// // Custom shader material for the gradient
// const GradientMaterial = new ShaderMaterial({
//   uniforms: {
//     color1: { value: new Color("#00ff00") }, // Start color of the gradient
//     color2: { value: new Color("#0000ff") }, // End color of the gradient
//   },
//   vertexShader: `
//     varying vec3 vPos;
//     void main() {
//       vPos = position;
//       gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
//     }
//   `,
//   fragmentShader: `
//     uniform vec3 color1;
//     uniform vec3 color2;
//     varying vec3 vPos;
//     void main() {
//       float mixValue = (vPos.y + 3.852) / 10.0; // Adjust this to fit your scene's scale
//       vec3 color = mix(color1, color2, mixValue);
//       gl_FragColor = vec4(color, 1.0);
//     }
//   `,
// });

// extend({ GradientMaterial });

// export function Landscape(props) {
//   const { nodes, materials } = useGLTF("assets/models/sceneneon4L2.glb");

//   const [lightsMaterial, waterMaterial] = useMemo(() => {
//     return [
//       new MeshStandardMaterial({
//         envMapIntensity: 0,
//         color: new Color("#ea6619"),
//         roughness: 0,
//         metalness: 0,
//         emissive: new Color("#f6390f").multiplyScalar(1),
//       }),
//       <MeshReflectorMaterial
//         transparent={true}
//         opacity={0.6}
//         color={"#23281b"}
//         roughness={0}
//         blur={[10, 10]} // Blur ground reflections (width, height), 0 skips blur
//         mixBlur={1} // How much blur mixes with surface roughness (default = 1)
//         mixStrength={20} // Strength of the reflections
//         mixContrast={1.2} // Contrast of the reflections
//         resolution={512} // Off-buffer resolution, lower=faster, higher=better quality, slower
//         mirror={0} // Mirror environment, 0 = texture colors, 1 = pick up env colors
//         depthScale={0} // Scale the depth factor (0 = no depth, default = 0)
//         minDepthThreshold={0} // Lower edge for the depthTexture interpolation (default = 0)
//         maxDepthThreshold={0.1} // Upper edge for the depthTexture interpolation (default = 0)
//         depthToBlurRatioBias={0.0025} // Adds a bias factor to the depthTexture before calculating the blur amount [blurFactor = blurTexture * (depthTexture + bias)]. It accepts values between 0 and 1, default is 0.25. An amount > 0 of bias makes sure that the blurTexture is not too sharp because of the multiplication with the depthTexture
//         debug={
//           0
//         } /* Depending on the assigned value, one of the following channels is shown */
//         reflectorOffset={0.0} // Offsets the virtual camera that projects the reflection. Useful when the reflective surface is some distance from the object's origin (default = 0)
//       />,
//     ];
//   }, []);

//   useEffect(() => {
//     const landscapeMat = materials["Material.009"];
//     landscapeMat.envMapIntensity = 0.75;

//     const treesMat = GradientMaterial.clone();
//     treesMat.uniforms.color1.value = new Color("#00ff00"); // Gradient start color
//     treesMat.uniforms.color2.value = new Color("#0000ff"); // Gradient end color
//     treesMat.envMapIntensity = 0.3;
//     treesMat.roughness = 1;
//     treesMat.metalness = 0;

//     nodes.trees_light.material = treesMat;
//   }, [materials, nodes]);

//   return (
//     <>
//       <group {...props} dispose={null}>
//         <mesh
//           castShadow
//           receiveShadow
//           geometry={nodes.landscape_gltf.geometry}
//           material={materials["Material.009"]}
//           position={[0, -3.852, -3.686]}
//           scale={[2.003, 1.938, 1.993]}
//         />
//         <mesh
//           castShadow
//           receiveShadow
//           geometry={nodes.landscape_borders.geometry}
//           material={materials["Material.010"]}
//           position={[0, -3.852, -3.686]}
//           scale={[2.003, 1.938, 1.993]}
//         />
//         <mesh
//           castShadow
//           receiveShadow
//           geometry={nodes.trees_light.geometry}
//           material={nodes.trees_light.material} // Use the updated material
//           position={[0, -3.852, -3.686]}
//           scale={[2.003, 1.938, 1.993]}
//         />
//       </group>
//       {/* <EffectComposer>
//         <Bloom intensity={1.5} luminanceThreshold={0.2} luminanceSmoothing={0.9} />
//       </EffectComposer> */}
//     </>
//   );
// }

// useGLTF.preload("/sceneneon4L2.glb");



































